import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

import { INDUSTRY_OVERVIEW_STATE, INDUSTRY_LEADERS_STATE } from "../MarketBuilder.types";

export const navigateToMarket = (marketName: string, country?: number) => {
    const { returnToState } = proNavigator.getParams();
    const market = UserCustomCategoryService.getCustomCategoryByName(marketName);
    if (!market) {
        return;
    }

    const hasIndustryOverviewClaim = isAvailable(swSettings.components.WebMarketResearchOverviewHome);
    const defaultTargetState = hasIndustryOverviewClaim ? INDUSTRY_OVERVIEW_STATE : INDUSTRY_LEADERS_STATE;

    const resolvedState = returnToState || defaultTargetState;

    const stateConfig = proNavigator.getState(resolvedState);
    const configId = proNavigator.getConfigId(stateConfig);
    const defaultParams = swSettings.components[configId]?.defaultParams ?? {};

    void proNavigator.go(resolvedState, {
        ...defaultParams,
        webSource: "Total",
        category: market.forUrl,
        country: country ?? defaultParams.country,
        ignoreFilterConsistency: true,
    });
};
